import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

function pickMessage(error) {
  const data = error.response?.data
  if (data?.message) return data.message
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.map((e) => e.message).join(' ')
  }
  return 'Request failed'
}

export const pricingManagementAdminService = {
  async list(includeInactive = true) {
    try {
      const response = await api.get('/pricing-management', {
        params: { include_inactive: includeInactive ? 'true' : 'false' }
      })
      const body = response.data
      return body?.data?.pricing_tiers ?? body?.data ?? []
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw new Error(msg)
    }
  },

  async update(id, payload) {
    try {
      const response = await api.put(`/pricing-management/${id}`, payload)
      const body = response.data
      toast.success(body?.message || 'Pricing tier updated')
      return body?.data?.pricing_tier ?? body?.data
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw Object.assign(new Error(msg), { response: error.response })
    }
  },

  async create(payload) {
    try {
      const response = await api.post('/pricing-management', payload)
      const body = response.data
      toast.success(body?.message || 'Pricing tier created')
      return body?.data?.pricing_tier ?? body?.data
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw Object.assign(new Error(msg), { response: error.response })
    }
  },

  async destroy(id) {
    try {
      const response = await api.delete(`/pricing-management/${id}`)
      const body = response.data
      toast.success(body?.message || 'Pricing tier deleted')
      return true
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw Object.assign(new Error(msg), { response: error.response })
    }
  }
}
